/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { bool, string } from 'prop-types';
import { NavLink } from 'react-router-dom';
import setClass from '../../common/set-class';
import { BASIC_DEFAULT_PROPS, BASIC_PROP_TYPES, getConfiguredCrumb, } from './util';
function BasicBreadcrumb({ currentLocation, crumbs, classes, noReactRouter, baseUrl, }) {
    const configuredCrumbs = crumbs.map((crumb) => getConfiguredCrumb(currentLocation, crumb, baseUrl));
    const wrapperClass = setClass([
        'breadcrumb__wrapper',
        'b-ol',
        'b-txt-ctrl5',
        'b-flex-vc',
        classes?.wrapper,
    ]);
    const itemClass = setClass(['breadcrumb__item', classes?.item]);
    const linkClass = setClass([
        'breadcrumb__link',
        'decorate-off',
        classes?.link,
    ]);
    const currentClass = setClass(['breadcrumb__current', classes?.current]);
    return (React.createElement("nav", { "aria-label": "breadcrumb" },
        React.createElement("ol", { className: wrapperClass },
            configuredCrumbs
                .slice(0, configuredCrumbs.length - 1)
                .map((crumb, idx) => (React.createElement("li", { key: idx, className: itemClass }, noReactRouter ? (React.createElement("a", { className: linkClass, href: crumb.to }, crumb.title)) : (React.createElement(NavLink, { to: crumb.to, exact: true, className: linkClass, activeClassName: currentClass }, crumb.title))))),
            React.createElement("li", { className: setClass([currentClass, itemClass]), "aria-current": "page" }, configuredCrumbs[configuredCrumbs.length - 1].title))));
}
BasicBreadcrumb.propTypes = {
    ...BASIC_PROP_TYPES,
    currentLocation: string.isRequired,
    noReactRouter: bool,
};
BasicBreadcrumb.defaultProps = {
    ...BASIC_DEFAULT_PROPS,
    noReactRouter: false,
};
export default BasicBreadcrumb;
